// Packages
import { FC } from 'react'
import { Link } from 'react-router-dom'
// Components
import MenuList from './MenuList'
// Constants
import menus from '../../constants/sidebarMenuData'
// Types
import { Menu, SubMenu } from '../../constants/type/menu'
import useAuth from '../../hooks/useAuth'
import { UserRole } from '../../types/generalType'

type IProps = {
  classes?: string
}

const Menus: FC<IProps> = () => {
  const { user } = useAuth()
  return (
    <div>
      {menus.map((item: Menu) =>
        item.hasSubMenu
          ? user?.role.find((role: UserRole) => item.accessRole?.includes(role)) && (
              <MenuList
                key={item.key}
                id={item.id}
                title={item.title}
                Icon={item.Icon}
                hasSubMenu={item.hasSubMenu}
                subMenuData={item.subMenu ?? []}
              />
            )
          : user?.role.find((role: UserRole) => item.accessRole?.includes(role)) && (
              <Link to={item.path ?? ''}>
                <MenuList
                  key={item.key}
                  id={item.id}
                  title={item.title}
                  Icon={item.Icon}
                  hasSubMenu={item.hasSubMenu}
                  subMenuData={item.subMenu ?? []}
                />
              </Link>
            ),
      )}
    </div>
  )
}

export default Menus
